import { render, staticRenderFns } from "./corporate-taxpayers-icon.vue?vue&type=template&id=401494dc"
import script from "./corporate-taxpayers-icon.vue?vue&type=script&lang=js"
export * from "./corporate-taxpayers-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports